import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { iniciais, avColor } from '../services/utils';

export default function Nav({ view, setView }) {
  const { usuario, logout } = useAuth();
  const av = avColor(usuario?.id || 0);
  const isAdmin      = usuario?.perfil === 'admin';
  const isSuperAdmin = ['admin', 'supervisor'].includes(usuario?.perfil);

  const navItems = [
    { id: 'chat',      icon: 'ti-message-circle-2', label: 'Atendimentos', show: true },
    { id: 'relatorios',icon: 'ti-chart-bar',         label: 'Relatórios',   show: isSuperAdmin },
    { id: 'atendentes',icon: 'ti-users',             label: 'Atendentes',   show: isAdmin },
    { id: 'config-ia', icon: 'ti-robot',             label: 'Agente de IA', show: isAdmin },
    { id: 'conexoes', icon: 'ti-plug-connected', label: 'Conexões', show: isAdmin },
    { id: 'crm', icon: 'ti-address-book', label: 'CRM', show: isSuperAdmin },
    { id: 'configuracoes', icon: 'ti-settings', label: 'Configurações', show: true },
  ];

  return (
    <nav style={styles.nav}>
      <div style={styles.logo} onClick={() => setView('chat')} title="Chat MJ">
        <i className="ti ti-brand-whatsapp" style={{ fontSize: 20, color: '#fff' }} />
      </div>
      <div style={styles.items}>
        {navItems.filter(n => n.show).map(n => (
          <button
            key={n.id}
            style={{ ...styles.navBtn, ...(view === n.id ? styles.navBtnActive : {}) }}
            onClick={() => setView(n.id)}
            title={n.label}
          >
            <i className={`ti ${n.icon}`} style={{ fontSize: 20 }} />
            <span style={styles.tooltip}>{n.label}</span>
          </button>
        ))}
      </div>
      <div style={styles.spacer} />
      <div style={styles.bottom}>
        <div style={{ ...styles.avatar, background: av.bg, color: av.color }} title={usuario?.nome}>
          {iniciais(usuario?.nome)}
        </div>
        <button style={styles.logoutBtn} onClick={logout} title="Sair">
          <i className="ti ti-logout" style={{ fontSize: 16 }} />
        </button>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    width: 64,
    background: '#0f0f0f',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '14px 0',
    gap: 2,
    flexShrink: 0,
  },
  logo: {
    width: 38,
    height: 38,
    borderRadius: 11,
    background: '#6C3FC5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    marginBottom: 12,
  },
  items: { display: 'flex', flexDirection: 'column', gap: 2, width: '100%', alignItems: 'center' },
  navBtn: {
    width: 42,
    height: 42,
    borderRadius: 10,
    border: 'none',
    background: 'transparent',
    color: '#8696a0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    transition: 'all 0.15s',
  },
  navBtnActive: {
    background: 'rgba(108,63,197,0.2)',
    color: '#6C3FC5',
  },
  tooltip: {
    position: 'absolute',
    left: 52,
    background: '#0f0f0f',
    color: '#fff',
    fontSize: 11,
    padding: '4px 10px',
    borderRadius: 6,
    whiteSpace: 'nowrap',
    pointerEvents: 'none',
    opacity: 0,
    transform: 'translateX(-4px)',
    transition: 'all 0.15s',
    border: '1px solid rgba(255,255,255,0.1)',
    zIndex: 999,
  },
  spacer: { flex: 1 },
  bottom: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 },
  avatar: {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 11,
    fontWeight: 600,
    cursor: 'default',
  },
  logoutBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    border: 'none',
    background: 'transparent',
    color: '#8696a0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s',
  },
};